import styled from 'styled-components';
import { theme } from '../theme';

export const SafetyContainer = styled.div`
  min-height: 100vh;
  background: ${theme.colors.background.secondary};
  padding: ${theme.spacing.md};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.sm};
  }
`;

export const SafetyHeader = styled.div`
  margin-bottom: ${theme.spacing.lg};
  padding-bottom: ${theme.spacing.md};
  border-bottom: 2px solid ${theme.colors.border.light};
`;

export const SafetyHeaderTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing.xs} 0;
  background: ${theme.colors.gradients.primary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1.5rem;
  }
`;

export const SafetyHeaderActions = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  margin-top: ${theme.spacing.md};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    flex-direction: column;
  }
`;

export const SafetyContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const SafetySection = styled.section`
  margin-bottom: ${theme.spacing.xl};
`;

export const SafetySectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing.xs} 0;
`;

export const SafetySectionDescription = styled.p`
  font-size: 0.875rem;
  color: ${theme.colors.text.secondary};
  margin: 0 0 ${theme.spacing.md} 0;
  line-height: 1.6;
`;

export const SafetyCard = styled.div`
  background: ${theme.colors.background.card};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.medium};
  padding: ${theme.spacing.lg};
  margin-bottom: ${theme.spacing.md};
  transition: all ${theme.transitions.normal};
  
  &:hover {
    box-shadow: ${theme.shadows.heavy};
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
  }
`;

export const SafetyCardHeader = styled.div`
  margin-bottom: ${theme.spacing.md};
`;

export const SafetyCardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing.xs} 0;
`;

export const SafetyCardDescription = styled.p`
  font-size: 0.875rem;
  color: ${theme.colors.text.secondary};
  margin: 0;
  line-height: 1.6;
`;

export const SafetyCardContent = styled.div`
  margin-bottom: ${theme.spacing.md};
`;

export const SafetyCardActions = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  flex-wrap: wrap;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    flex-direction: column;
  }
`;

export const SafetyLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.xl};
  color: ${theme.colors.text.secondary};
  font-size: 1rem;
`;

export const SafetyError = styled.div`
  background: rgba(220, 53, 69, 0.1);
  color: ${theme.colors.error};
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  margin-bottom: ${theme.spacing.md};
  border: 1px solid ${theme.colors.error};
  text-align: center;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.xl};
  text-align: center;
  background: ${theme.colors.background.card};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.light};
`;

export const EmptyStateIcon = styled.div`
  font-size: 4rem;
  margin-bottom: ${theme.spacing.md};
  opacity: 0.5;
`;

export const EmptyStateTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing.xs} 0;
`;

export const EmptyStateDescription = styled.p`
  font-size: 0.875rem;
  color: ${theme.colors.text.secondary};
  margin: 0;
  line-height: 1.6;
  max-width: 400px;
`;






